import { UnifiedAccServiceComponent } from './UnifiedAccServiceComponent';
import { UnifiedAccReconnectButton } from './UnifiedAccReconnectButton';
export const UnifiedAccReconnectionConfig = {
  reconnectButton: UnifiedAccReconnectButton,
  serviceComponent: UnifiedAccServiceComponent
};